import { render, staticRenderFns } from "./press-releases.vue?vue&type=template&id=7e064f78"
import script from "./press-releases.vue?vue&type=script&lang=js"
export * from "./press-releases.vue?vue&type=script&lang=js"
import style0 from "./press-releases.vue?vue&type=style&index=0&id=7e064f78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports